import React from 'react';
import SolutionTempContainer from 'containers/SolutionTempContainer';

export default function SolutionTempPage() {
  return (
    <SolutionTempContainer />
  )
}
